import IconButton from '@/features/ui/buttons/components/IconButton'
import EditIcon from '@/features/ui/icons/components/EditIcon'
import { FC } from 'react'

interface EditButtonProps {
    onPress: () => void
}

const EditButton: FC<EditButtonProps> = ({ onPress }) => {
    return <IconButton Icon={EditIcon} mode="rounded" size={24} onPress={onPress} />
}

export default EditButton
